import { Alert } from '@components'
import { ImageOff } from 'lucide-solid'
import { type ParentProps, Show } from 'solid-js'
import { Grid } from 'styled-system/jsx'

export const CropZone = (props: ParentProps<{ showCropper: boolean }>) => {
	return (
		<div>
			<Show
				when={props.showCropper}
				fallback={
					<Grid
						height="100%"
						justifyContent="center"
						alignItems="center"
					>
						<Alert.Root {...props}>
							<Alert.Icon asChild={(iconProps) => <ImageOff {...iconProps()} />} />
							<Alert.Content>
								<Alert.Title>No Image</Alert.Title>
								<Alert.Description>Upload an image to get started</Alert.Description>
							</Alert.Content>
						</Alert.Root>
					</Grid>
				}
			>
				{props.children}
			</Show>
		</div>
	)
}
